/// <amd-module name="Wit/WorkItemForm/Attachments/index" />
export * from './AttachmentsTab';
